<template>
  <modal name='modal'  :resizable='true' :adaptive='true'  width='700px' height='550px' >
<div style='float:right'>
<button  v-on:click="close"><span aria-hidden="true" >&times;</span></button>
</div></br>
  

    <div>
    <carousel center='center' :autoplay='true' :responsive="{0:{items:1,nav:false},600:{items:1,nav:false}}" :nav='false'>
        <div class='item' style="text-align: center;height:460px" v-for="notificacion of notificaciones" :key="notificacion.id">

      <h3>{{notificacion.descripcion}}</h3>
       <img  class="img-fluid" v-if="notificacion.url_image!=null" style="width:100%;height:380px;text-align:center;margin-top:10px;padding:4px" :src=" urlPage + '/' + notificacion.url_image">
      
      </div>


    </carousel>
    </div>
<div style='bottom:0;position:absolute;text-align:center;left: 0%;right: 0%' >
    

    </div>


  </modal>
</template>

<script>
export default {
  props: {

    notificaciones : {
      required : true,
      type : Array 
    },
 
  },   

   methods: {
      close: function () {

        this.$modal.hide('modal');


      }


   },
  data () {
    return {
      urlPage: window.location.origin,
    

    }
  },
    mounted() {

      if(this.notificaciones!=''){
              this.$modal.show('modal');


      }
 
      


  },
}
</script>






// WEBPACK FOOTER //
// resources/assets/js/components/element/notyModal.vue